import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_SK.json';
import audios from './ASTROLOGY_AUDIOS_SK.json';

export const ASTROLOGY_DATA_SK: ServiceData = {
  articles,
  audios,
};
